import React from 'react';
import styled from 'styled-components';
import { Table } from 'semantic-ui-react';

const StyledTable = styled(Table)`
  &&& {
    border: 1px solid #ccc;
    width: 100%;
    th, td {
      border: 1px solid #ccc;
      padding: 10px;
      text-align: left;
      vertical-align: top;
    }

    th {
      background-color: #dff0d8;
      font-weight: bold;
    }

    td:first-child {
      font-weight: bold;
    }
  }
`;

const Description = styled.p`
  margin-bottom: 1em;
  font-size: 1em;
`;

const text = 'Diese Einstellung wirkt sich über die Vorbelegung der Schnitthäufigkeit und über die Ertragsfaktoren (siehe Modul "Trockenmasseertrag Anwelkgut") auf den Ertrag aus.';

const LocationTableTooltip: React.FC = () => (
  <div>
    <Description>
      {text}
    </Description>
    <StyledTable celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Standort</Table.HeaderCell>
          <Table.HeaderCell>Wasserversorgung</Table.HeaderCell>
          <Table.HeaderCell>Bodenqualität</Table.HeaderCell>
          <Table.HeaderCell>Pflanzenbestand</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Table.Row>
          <Table.Cell>sehr günstig, wenn ...</Table.Cell>
          <Table.Cell>Niederschläge &gt; 1000 mm im Jahr; gleichmäßig verteilt</Table.Cell>
          <Table.Cell>tiefgründig, sehr humusreich, keine Bodenverdichtungen</Table.Cell>
          <Table.Cell>hoher Anteil an Weidelgras und Wiesenrispe; dichte Grasnarben</Table.Cell>
        </Table.Row>

        <Table.Row>
          <Table.Cell>günstig, wenn ...</Table.Cell>
          <Table.Cell>Niederschläge 1000-800 mm im Jahr; gleichmäßig verteilt und/oder Grundwasseranschluß</Table.Cell>
          <Table.Cell>tiefgründig, humusreich, keine Bodenverdichtungen</Table.Cell>
          <Table.Cell>deutlicher Anteil an Weidelgras, Wiesenrispe, Wiesenfuchsschwanz, Knaulgras, Glatthafer; dichte Grasnarben</Table.Cell>
        </Table.Row>

        <Table.Row>
          <Table.Cell>weniger günstig, wenn ...</Table.Cell>
          <Table.Cell>Niederschläge &lt; 800 mm im Jahr und kein Grundwasseranschluß oder regelmäßige Trockenperioden April - September oder Staunässe</Table.Cell>
          <Table.Cell>flachgründig-sandig oder deutliche Bodenverdichtungen (Fahrspuren, Pfützenbildung)</Table.Cell>
          <Table.Cell>Anteil an unerwünschten Arten &gt; 20% (Gemeine Rispe, Ampfer, Hahnenfußarten) oder lückige Grasnarben (&gt;20%)</Table.Cell>
        </Table.Row>
      </Table.Body>
    </StyledTable>
  </div>
);

export default LocationTableTooltip;